import { zoneAdapter } from "@/services/adapters";

export function zoneTransformResponse(data) {
  data = JSON.parse(data);
  if (data.zone) data.zone = zoneAdapter(data.zone);
  if (data.zones) data.zone = data.zones.map((zone) => zoneAdapter(zone));
  return data;
}
